import { getCountryFlagUrl } from "assets/icons/flagUrls";
import cn from "classnames";
import { Loader } from "components/ui/Loader/Loader";
import { SITE_NAME } from "constants/siteName";
import { useSiteName } from "context/SiteName.context";
import { ArrowDownIcon } from "../Icons";
import style from "./PhoneCode.module.scss";

type Country = {
  name: string;
  iso: string;
  countryCode: string;
};

type PhoneCodeProps = {
  countryData: Country;
  isOpenList: boolean;
  setIsOpenList: (value: boolean) => void;
  isCountryLoading: boolean;
};

export const PhoneCode = ({ countryData, isOpenList, setIsOpenList, isCountryLoading }: PhoneCodeProps) => {
  const flagSrc = getCountryFlagUrl(countryData.countryCode);
  const { siteName } = useSiteName();
  return (
    <>
      {isCountryLoading ? (
        <Loader className={style.loader} />
      ) : (
        <div onClick={() => setIsOpenList(!isOpenList)} className={style.phoneCode}>
          <img className={style.phoneCodeFlag} src={flagSrc} alt="flagIcon" />
          <input
            readOnly
            type="text"
            value={countryData?.iso || ""}
            className={cn(style.phoneCodeInput, {
              [style.phoneCodeInputChineseBrothers]: siteName === SITE_NAME.CHINESE_BROTHERS,
            })}
          />
          <ArrowDownIcon className={cn(style.openListIcon, { [style.openListIconActive]: isOpenList })} />
        </div>
      )}
    </>
  );
};
